import { Component, OnInit, Input, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ThemeService } from '@egret/shared/services/theme.service';
import { LayoutService } from '@egret/shared/services/layout.service';
import { ToolbarService } from 'bookraw/shared/services/toolbar.service';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html'
})
export class HeaderSideComponent implements OnInit {
  @Input() notificPanel;

  public egretThemes;
  public layoutConf: any;
  public header: TemplateRef<any>;

  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    private toolbarService: ToolbarService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;

    // ha változik a template akkor frissítjük a headert
    this.toolbarService.template.subscribe((template) => {
      this.header = template;
      this.cdr.detectChanges();
    });
  }

  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full'
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed'
    });
  }
}
